import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import { HttpClientModule } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import './resources/packages.resource';
import { packagesReducer } from './store/packages.reducer';
import { PackagesEffects } from './store/packages.effects';
import { CommonModule } from '../common/common.module';
import { ClustersModule } from '../clusters/clusters.module';
import { JobsModule } from '../jobs/jobs.module';
import { PackagesListComponent } from './components/packages-list.component';
import { PackageListItemComponent } from './components/package-list-item.component';
import { PackageWorkspaceFormComponent } from './components/package-workspace-form.component';

@NgModule({
  imports: [
    BrowserModule,
    UpgradeModule,
    HttpClientModule,
    FormsModule,
    StoreModule.forFeature('packages', packagesReducer),
    EffectsModule.forFeature([PackagesEffects]),
    CommonModule,
    TranslateModule,
    NgxPermissionsModule,
    MatTooltipModule,
    MatMenuModule,
    MatSlideToggleModule,
    ClustersModule,
    JobsModule,
  ],
  providers: [],
  declarations: [PackagesListComponent, PackageListItemComponent, PackageWorkspaceFormComponent],
  entryComponents: [PackagesListComponent, PackageListItemComponent, PackageWorkspaceFormComponent],
})
export class PackagesModule {}
